module.exports = __webpack_public_path__ + "static/media/VOCAB-03.ae9dfe4a.png";